
export default {
  profileSelector: {
    activeProfile: 'Attiva'
  }
}
